
import { Component, Vue } from 'vue-property-decorator'
import Recorder from 'recorder-js'
import { getUserMedia, getVal, deviceVibrate } from '@/utils/helpers'
import * as Common from '@/api/common'
import { AppModule } from '@/store/modules/app'

@Component
export default class VoiceRecorder extends Vue {
  // 是否在收音状态
  isRecording = false
  recorder: any = null

  // 动画显示的长度
  animationCount = 10
  // 最大收音时长
  maxCount = 60
  // 默认收音时长
  defaultCountdown = 60
  // 定时器
  timer: any = null

  // 配置文件
  readonly recordConfig = window.config.recordConfig

  // 处理录音动画的延迟时间
  handleScend(index: number) {
    const start = +(`0.${index}`)
    let result = '0s'
    if (index < this.animationCount) {
      result = (start + -1.1) + 's'
    }
    return result
  }

  // 开始录音
  startRecord() {
    this.recorder = this.initRecorder()

    getUserMedia({ audio: true}).then((stream: MediaStream) => {
      deviceVibrate(1000)
      this.recorder.init(stream)
      return this.recorder.start()
    }).then((res: any) => {
      this.isRecording = true
      this.startCountdown()
    }).catch((err) => {
      console.error(err)
    })
  }

  // 清除定时器
  clearTimeInterval() {
    clearInterval(this.timer)
    this.timer = null
  }
  // 倒计时指定时间，默认60s
  startCountdown() {
    if (this.timer) {
      this.clearTimeInterval()
    }
    this.timer = setInterval(() => {
      this.defaultCountdown -= 1
      if (this.defaultCountdown <= 0) {
        this.clearTimeInterval()
        this.defaultCountdown = this.maxCount
        this.stopRecord(true)
      }
    }, 1000)
  }

  initRecorder() {
    if (this.recorder) {
      return this.recorder
    } else {
      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)()
      return new Recorder(audioContext)
    }
  }

  /*
   * 结束收音
   * @param isTimeout 是否自动结束收音： true 自动结束   false 手动结束
   */ 
  stopRecord(isTimeout: boolean) {
    if (this.isRecording) {
      const message: any = this.$t('inSpeechRecognition')
      AppModule.setTip(message)
      AppModule.setSpinning(true)
      this.recorder.stop().then(({ blob }: { blob: Blob }) => {
        this.isRecording = false
        this.clearTimeInterval()
        this.sendVoice(blob, isTimeout)
      })
    } else {
      console.warn('录音已经结束')
    }
  }

  sendVoice(blob: Blob, isTimeout: boolean) {
    const formData = new FormData()
    formData.append('file', blob);
    Common.transToText(formData).then((res: any) => {
      const content = getVal(res, 'content', '')
      let time = 0
      if (isTimeout) {
        // 自动结束，取最大时长
        time = this.maxCount
      } else {
        // 手动结束，取已录音时长
        time = this.maxCount - this.defaultCountdown
      }

      if (this.recordConfig.sendType === 'text') {
        this.$emit('translate', res.content)
      } else {
        this.$emit('sendVoice', {
          blob,
          content: res.content,
          time: time,
          path: res.path
        })
      }
    }).catch(err => {
      const message = err.message || '转文本异常'
      this.$message.error(message)
    }).finally(() => {
      this.defaultCountdown = this.maxCount
      AppModule.setSpinning(false)
    })
  }
}

